// Smooth Scroll
module.exports = function () {
// Select all links with hashes
    document.querySelectorAll('a[href*="#"]').forEach(function(link) {
        // Remove links that don't actually link to anything
        if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '#0') {
            link.addEventListener('click', function(event) {
                // On-page links
                if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                    location.hostname == this.hostname) {
                    // Figure out element to scroll to
                    var target = document.querySelector(this.hash);
                    target = target ? target : document.querySelector('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        var headerHeight = document.querySelector('.main-header').offsetHeight;
                        var scrollTopPos = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                        window.scrollTo({
                            top: scrollTopPos,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        }
    });

    function scrollOnPageLoad() {
        // Scroll to top right away
        if (window.location.hash) window.scrollTo(0, 0);
        // Void some browsers issue
        setTimeout(function() {
            window.scrollTo(0, 0);
        }, 1);
        var hashLink = window.location.hash;
        if (hashLink && document.querySelector(hashLink)) {
            window.addEventListener('DOMContentLoaded', function() {
                // Only if we have an anchor on the URL
                // Smooth scroll to the anchor id
                var headerHeight = document.querySelector('.main-header').offsetHeight;
                var target = document.querySelector(hashLink);
                var scrollTopPos = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
                window.scrollTo({
                    top: scrollTopPos,
                    behavior: 'smooth'
                });
            });
        }
    }

    scrollOnPageLoad();
}